import { AspectStore } from '@wix/wix-bootstrap-greyhound-api';
import {
  BootstrapContextServerNextjs,
  ExternalSearchResult,
} from '../../types';

export const EXTERNAL_RESOURCE_PAGE_SIZE = 12;

export type ExternalResourceSearchDto = {
  query: string;
  page: number;
  locale: string;
  externalResourcesType?: ExternalResourceType[];
};

export enum ExternalResourceType {
  WIX_BLOG = 'wix-blog',
  WIX_LEARN = 'wix-learn',
  WIX_VELO = 'wix-velo',
  WIX_SEO_LEARN = 'wix-seo-learn',
}

export const getImageUrl = (imageName: string) =>
  `https://static.wixstatic.com/media/${imageName}/v1/fill/w_178,h_134,al_c,q_85,enc_auto/${imageName}`;

export type NormalizedResource = {
  title: string;
  description: string;
  source: ExternalResourceType;
  url: string;
  topics?: string[];
  documentImage?: {
    height: number;
    url: string;
    width: number;
  };
};

export type ExternalResourceConfig<T> = {
  type: ExternalResourceType;
  fetch: (
    aspects: AspectStore,
    context: BootstrapContextServerNextjs,
    dto: ExternalResourceSearchDto
  ) => Promise<T>;
  parser: (data: T) => ExternalSearchResult;
};
